<div class="card">
  <div class="data-header">

    <button mat-raised-button color="primary" (click)="openCreateDialog()">
       Nouvelle évaluation
    </button>

    <mat-form-field appearance="outline" class="filter-field">
      <mat-label>Rechercher</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input matInput (keyup)="applyFilter($event)" placeholder="Nom, prénom, application...">
    </mat-form-field>

     <button mat-stroked-button color="primary" (click)="exportData()">
      <mat-icon>file_download</mat-icon> Exporter tout
    </button>
  </div>

  <mat-table
    class="mat-elevation-z8 table-container"
    [dataSource]="dataSource"
    matSort
    (matSortChange)="announceSortChange($event)">

    <!-- Nom -->
    <ng-container matColumnDef="nom">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Nom</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.nom }}</mat-cell>
    </ng-container>

    <!-- Prénom -->
    <ng-container matColumnDef="prenom">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Prénom</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.prenom }}</mat-cell>
    </ng-container>

    <!-- Application -->
    <ng-container matColumnDef="application">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Application</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.application }}</mat-cell>
    </ng-container>

    <!-- UO -->
    <ng-container matColumnDef="uo">
      <mat-header-cell *matHeaderCellDef>UO</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span *ngIf="row.uniteOrganisationnelle; else noUo">
          {{ row.uniteOrganisationnelle.code }}
        </span>
        <ng-template #noUo><span class="no-data">—</span></ng-template>
      </mat-cell>
    </ng-container>

    <!-- Date démarrage -->
    <ng-container matColumnDef="dateDemarrage">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Démarrage</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.dateDemarrage | date: 'dd/MM/yyyy' }}</mat-cell>
    </ng-container>

    <!-- Statut -->
    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="statut-col">Statut</mat-header-cell>
      <mat-cell *matCellDef="let row" class="statut-col">
        <span class="badge-statut" [ngClass]="{
          'statut-brouillon': row.status === 'BROUILLON',
          'statut-validee':   row.status === 'VALIDEE',
          'statut-archivee':  row.status === 'ARCHIVEE'
        }">{{ row.status }}</span>
      </mat-cell>
    </ng-container>

    <!-- Actions -->
    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef class="actions-td">Actions</mat-header-cell>
      <mat-cell *matCellDef="let row" class="actions-td">

        <button mat-icon-button
                (click)="openEvaluation(row)"
                matTooltip="Ouvrir l'évaluation"
                color="primary">
          <mat-icon>open_in_new</mat-icon>
        </button>

        <button mat-icon-button
                (click)="$event.stopPropagation(); deleteEvaluation(row)"
                matTooltip="Supprimer totalement l'évaluation"
                color="warn"
                aria-label="Supprimer complètement l'évaluation">
          <mat-icon>delete_forever</mat-icon>
        </button>

      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"
             class="clickable-row"
             (click)="openEvaluation(row)">
    </mat-row>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
        <mat-icon>search_off</mat-icon>
        Aucune évaluation trouvée
      </td>
    </tr>

  </mat-table>
</div>